import { render, staticRenderFns } from "./customerReceSummery.vue?vue&type=template&id=67f941f5&scoped=true"
import script from "./customerReceSummery.vue?vue&type=script&lang=js"
export * from "./customerReceSummery.vue?vue&type=script&lang=js"
import style0 from "./customerReceSummery.vue?vue&type=style&index=0&id=67f941f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f941f5",
  null
  
)

export default component.exports